import ShiftCard, { ShiftCardProps } from './ShiftCard';

export interface DetailShiftCardProps extends Omit<ShiftCardProps, 'status'> {}

const DetailShiftCard: React.FC<DetailShiftCardProps> = (props) => <ShiftCard {...props} status="NONE" />;

export default DetailShiftCard;
